<script lang="ts">
  import { Menu, MenuItem, MenuItems } from "@rgossiaux/svelte-headlessui";
  import { authentication } from "@utils/keycloak";
  import { EdgeStatus } from "@client";
  import Youtube from "@components/Video/youtube.svelte";
  import HelpMenuButton from "./HelpMenuButton.svelte";
  import TutorialDialog from "./TutorialDialog.svelte";
  import { nodeTypes } from "@utils/nodeTypes";
  import { dataStore } from "@stores/datastore";
  import { resourceTypeOptions } from "@components/Actions/CreateResource/Form.svelte";
  import { displayStore } from "@stores/displaystore";

  let youtube;
  const { _nodes, _stories, _graphData, _resources } = dataStore;
  let dialogTutorial = {
    dialog:undefined,
    open:undefined,
    close:undefined
  }
  let dialogInfoData = {
    dialog:undefined,
    open:undefined,
    close:undefined
  }
  let canvasResources
  let canvasNodesTypes
  function classNames(...classes: (string | false | null | undefined)[]) {
    return classes.filter(Boolean).join(" ");
  }
  const { _theme } = displayStore;

  function displayCanvasResources() {
    const ctx = canvasResources.getContext('2d');

    // Données de l'histogramme
    const data = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    const barWidth = 100;
    const barSpacing = 25;

    // Dimensions du canvas
    const canvasWidth = canvasResources.width;
    const canvasHeight = canvasResources.height;

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    let total = $_resources.length
    const ressourceValue = resourceTypeOptions.map((type) => {
      return {value_edge:$_resources.filter(resource => resource.type == type.value && resource.edge_id != null).length,
              value_node:$_resources.filter(resource => resource.type == type.value && resource.node_id != null).length,
              value_story:$_resources.filter(resource => resource.type == type.value && resource.story_id != null).length,
              type: type.label,
              deltaX: 15}
    })

    ressourceValue.find(res => res.type == "Formal definition").deltaX = 50
    ressourceValue.find(res => res.type == "Scientific paper").deltaX = 40
    ressourceValue.find(res => res.type == "Montoring data").deltaX = 40

    ressourceValue.forEach((value, index) => {
        const barHeight_story = (value.value_story / total) * (canvasHeight - 50);
        const barHeight_edge = (value.value_edge / total) * (canvasHeight - 50);
        const barHeight_node = (value.value_node / total) * (canvasHeight - 50);
        const x = index * (barWidth + barSpacing) + 20;
        const y_story = canvasHeight - barHeight_story - 30;
        const y_edge = canvasHeight - barHeight_edge - barHeight_story - 30;
        const y_node = canvasHeight - barHeight_node - barHeight_story - barHeight_edge - 30;

        ctx.fillStyle = 'blue';
        ctx.fillRect(x, y_story, barWidth, barHeight_story);
        ctx.fillStyle = 'orange';
        ctx.fillRect(x, y_edge, barWidth, barHeight_edge);
        ctx.fillStyle = 'green';
        ctx.fillRect(x, y_node, barWidth, barHeight_node);

        // Ajouter des étiquettes
        ctx.fillStyle = $_theme == "dark" ? "white": 'black';
        ctx.font = "14px sherif";
        ctx.fillText(value.type, x + barWidth / 2 - value.deltaX, canvasHeight - 10);
        ctx.fillText(value.value_story+value.value_edge+value.value_node, x + barWidth / 2 - 5, canvasHeight- barHeight_node - barHeight_story - barHeight_edge -30  - 5);
    });

  }

  function displayCanvasNodesTypes() {
    const ctx = canvasNodesTypes.getContext('2d');

    // Données de l'histogramme
    const data = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    const barWidth = 100;
    const barSpacing = 25;

    // Dimensions du canvas
    const canvasWidth = canvasNodesTypes.width;
    const canvasHeight = canvasNodesTypes.height;

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    let total = $_nodes.length
    const ressourceValue = Object.keys(nodeTypes).map((nodeType) => {
      return {value:$_nodes.filter(node => node.type == nodeType).length, type: nodeType, deltaX: 15}
    })

    ressourceValue.find(res => res.type == "complimentary_capital").deltaX = 60
    ressourceValue.find(res => res.type == "ecosystem_service").deltaX = 50
    ressourceValue.find(res => res.type == "good_and_benefit").deltaX = 50
    ressourceValue.find(res => res.type == "impact_on_welfare").deltaX = 50
    ressourceValue.find(res => res.type == "component").deltaX = 25

    ressourceValue.forEach((value, index) => {
        const barHeight = (value.value / total) * (canvasHeight - 50);
        const x = index * (barWidth + barSpacing) + 20;
        const y = canvasHeight - barHeight - 30;

        ctx.fillStyle = 'blue';
        ctx.fillRect(x, y, barWidth, barHeight);

        // Ajouter des étiquettes
        ctx.fillStyle = $_theme == "dark" ? "white": 'black';
        ctx.font = "14px sherif";
        ctx.fillText(value.type, x + barWidth / 2 - value.deltaX, canvasHeight - 10);
        ctx.fillText(value.value, x + barWidth / 2 - 5, y - 5);
    });

  }

  function resolveClass({
    active,
    disabled,
  }: {
    active: boolean;
    disabled: boolean;
  }) {
    return classNames(
      "flex justify-between w-full px-4 py-2 text-sm leading-5 text-left",
      disabled && "cursor-not-allowed opacity-50"
    );
  }

  $: $_theme && canvasResources && displayCanvasResources()
  $: $_theme && canvasNodesTypes && displayCanvasNodesTypes()
</script>

<Youtube bind:this={youtube} />

<TutorialDialog bind:this={dialogTutorial.dialog} bind:open={dialogTutorial.open} bind:close={dialogTutorial.close}>
  <div
    class="flex flex-row inline-block w-full p-4 text-left align-middle bg-base-200 rounded-2xl" slot="content"
    style="width:130vh; "
  >
    <div style="min-width: 55%;" class="rounded-r-lg">
      <img
      src="assets/tutorial_dapsiwrm_{$_theme == "dark" ? "dark": "light"}.png"
      class="object-cover col-span-2 "
      alt="Dapsiwrm class diagram"
      style="width:100%"
    />
    </div>
    <div style="padding-left: 30px; font-size:12px" >
      <p>The DAPSI(W)R(M) framework is a comprehensive approach to environmental management that considers social, economic, and environmental factors.</p>

      <p>It consists of six core elements: Drivers, Activities, Pressures, State, Impacts, and Responses :</p>

      <ul style="list-style:disc; padding:20px">
        <li><b style="color:{nodeTypes["driver"].color()}">Drivers</b>: Basic human needs and wants - based on Maslow's hierarchy of needs.</li>
        <li><b style="color:{nodeTypes["activity"].color()}">Activities</b>: The things Individuals or groups of people "do" to satisfy their needs and wants.</li>
        <li><b style="color:{nodeTypes["complimentary_capital"].color()}">Complementary Capital</b>: The social or economic capital inputs to (or outputs of) <b style="color:{nodeTypes["activity"].color()}">Activities</b>.​</li>
        <li><b style="color:{nodeTypes["pressure"].color()}">Pressures</b>: The chemical and/or biological and/or physical additions or subtractions to components of the environment resulting from <b style="color:{nodeTypes["activity"].color()}">activities</b>. <b style="color:{nodeTypes["pressure"].color()}">Pressure</b> causes result in changes in state to environmental components.</li>
        <li><b style="color:{nodeTypes["component"].color()}">State - Components</b>: The concepts that constitute the Environment, including biotic, chemical or physical (energy) concepts. Some concepts are aggregations of "lower level" concepts.</li>
        <li><b style="color:{nodeTypes["ecosystem_service"].color()}">State - Final Ecosystem Services</b>: Environmental components and processes that have the potential to be converted (by an <b style="color:{nodeTypes["activity"].color()}">Activity</b>) into human-usable <b style="color:{nodeTypes["good_and_benefit"].color()}">goods and benefits</b>.</li>
        <li><b style="color:{nodeTypes["good_and_benefit"].color()}">Impacts - Goods and Benefits</b>: Are human-usable goods and benefits which result from a human Action and an <b style="color:{nodeTypes["ecosystem_service"].color()}">Ecosystem Service</b>.</li>
        <li><b style="color:{nodeTypes["impact_on_welfare"].color()}">Impacts - Human Welfare</b>: Are the impacts on individuals and society of an over or undersupply of <b style="color:{nodeTypes["good_and_benefit"].color()}">Goods and Benefits</b> relative to their Needs/Wants (<b style="color:{nodeTypes["driver"].color()}">Drivers</b>)</li>
        <li><b style="color:{nodeTypes["response"].color()}">Responses</b><b> (as measures)</b>: The various types of intervention that can be applied to adapt to or mitigate against <b style="color:{nodeTypes["impact_on_welfare"].color()}">Impacts on Human Welfare</b>.</li>
      </ul>

      <p>The framework helps to understand and communicate the environment as a system and its interdependencies with social and economic systems by highlighting the cause-effect relationships between the different elements. The DAPSI(W)R(M) framework provides decision-makers with a systematic and objective approach to environmental management that can help to address the complexities of environmental issues and support sustainable development by integrating social, economic, and environmental factors.</p>
    </div>
  </div>
</TutorialDialog>

<TutorialDialog bind:this={dialogInfoData.dialog} bind:open={dialogInfoData.open} bind:close={dialogInfoData.close} title="Content Dashboard">
  <div
    class="flex flex-row inline-block w-full p-4 text-left align-middle bg-base-200 rounded-2xl" slot="content"
    style="width:130vh; "
  >
    <div style="padding-left: 30px; font-size:16px" >

      <ul style="list-style:disc; padding:20px">
        <li><b>Concepts</b>: {$_nodes.length} (validated: {$_nodes.filter(node => node.validated).length} - with description: {$_nodes.filter(node => node.description!=null).length} - with synonyms: {$_nodes.filter(node => node.synonyms!=null).length})</li>
        <canvas bind:this={canvasNodesTypes} width="1200" height="200"></canvas>
        <!-- <ul style="list-style:disc; padding:20px">
          {#each Object.keys(nodeTypes) as nodeType}
          <li><b>{nodeType}</b>: {$_nodes.filter(node => node.type == nodeType).length}</li>
	        {/each}
        </ul> -->
        <li><b>Connections</b>: {$_graphData.links.length} (validated: {$_graphData.links.filter(link => link.status === EdgeStatus.VALIDATED).length})</li>
        <li><b>Evidences</b>: {$_resources.length} (stories: blue, edges: orange, nodes: green)</li>
        <canvas bind:this={canvasResources} width="800" height="200"></canvas>

        <!-- <ul style="list-style:disc; padding:20px">
          {#each resourceTypeOptions as resourceType}
          <li><b>{resourceType.label}</b>: {$_resources.filter(resource => resource.type == resourceType.value).length}</li>
	        {/each}
        </ul> -->

        <li><b>Stories</b>: {$_stories.length}</li>
      </ul>


    </div>
  </div>
</TutorialDialog>

{#if $authentication}
  <Menu  style="height: 32px">
    <HelpMenuButton />
    <MenuItems
      class="absolute z-20 w-56 mt-2 origin-top-right border divide-y rounded-md shadow-lg outline-none bg-base-100 border-base-200 divide-base-200 right-10"
    >
      <MenuItem as="div" class={resolveClass}>
        <div class="flex-row w-full">
          <span class="flex items-center">
            <a href="https://egreenlearning.ead.ae/topic/27" target="_blank" class="w-full text-left">Online Training Course</a>
          </span>
          <hr class="mt-2 mb-2"/>

          <span class="flex items-center">
            <button on:click={() => youtube.show()}> DAPSIwRm Video (36 min)</button>
          </span>
          <span class="flex items-center">
            <a href="/assets/20221128 Class Diagram.pdf" target="_blank"
              >Class Diagram</a
            >
          </span>
          <span class="flex items-center">
            <button on:click={() => dialogInfoData.dialog.open()}> Content Dashboard </button>
          </span>

          <hr class="mt-2 mb-2"/>

          <span class="flex items-center">
            <a href="https://naturalsolutions.atlassian.net/servicedesk/customer/portal/9/group/-1" target="_blank">Support platform</a>
          </span>
        </div>
      </MenuItem>
    </MenuItems>
  </Menu>
{:else}
  <div>Sign In</div>
{/if}


<style>
  li {
    padding-bottom: 5px;
  }
</style>